import { render, staticRenderFns } from "./UserApprovalList.vue?vue&type=template&id=5323b8de&"
import script from "./UserApprovalList.vue?vue&type=script&lang=js&"
export * from "./UserApprovalList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports